import i18n from "@i18n";
import { TOAST_TYPE_WARNING } from "../services/constants";
import { showToastNotification } from "./toast";

const { t } = i18n;

export function fileFormatNotSupportedToast() {
  return async (dispatch) => {
    dispatch(
      showToastNotification({
        content: t("Merge cannot be done for this combination Please try again with supported files or estimates."),
        type: TOAST_TYPE_WARNING,
      }),
    );
  };
}

export function UnnamedEstimateNotSupportedToast(errorMessage) {
  return async (dispatch) => {
    dispatch(
      showToastNotification({
        content: errorMessage,
        type: TOAST_TYPE_WARNING,
      }),
    );
  };
}
